export default [
    // members sidebar index route
    {
        path: '/residents',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/residents/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'residents.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/residents/default.vue'),
                meta: {
                    layout: 'dashboard'
                }
            },
            {
                path: 'profile/:id',
                name: 'residents.profile',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/residents/profile.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
